import React, { useEffect, useMemo, useRef } from "react";
import * as css from "./style.module.less";
import weBackGround from "../../assets/we_background.png";
import lightBackGround from "../../assets/light_background.png";
import weIcon from "../../assets/app-we-icon.svg";
import lightIcon from "../../assets/app-light-icon.svg";
import addIcon from "../../assets/add-icon.svg";
import configIcon from "../../assets/config.icon.svg";
import robotBackground from "../../assets/robot_background.png";
import robotIcon from "../../assets/robot_icon.svg";
import { Button, message } from "@cloud/atom-ui";
import classNames from "classnames";
import useMappedState from "@src/utils/useMappedState";
import { useDispatch } from "redux-react-hook";
import * as actions from "@src/actions/index";
import history from "@src/utils/history";
import { doAddAbility } from "../../server/index";
import { queryString, getAppPathFromType, APP_TYPE } from "@src/utils/common";
import { abilityType } from "../../../../utils/utils";
import {urlDomainDeal} from "@src/utils/common";

import _ from "lodash";

const AppCapabilitiesCard = props => {
  const dispatch = useDispatch();
  const { appInfo } = useMappedState("root");
  const type = queryString("type");
  // 应用功能数据上一次快照
  const oldAbilityRef = useRef([]);
  const addAbilityRef = useRef(false);

  const pageList = {
    wecode: "applicationWe",
    h5: "applicationLight",
    robot: "applicationRobot"
  };

  useEffect(() => {
    if (!Object.keys(appInfo || {}).length) return;
    if (
      JSON.stringify(oldAbilityRef.current.sort()) !==
      JSON.stringify(appInfo?.abilityList?.sort() || [])
    ) {
      if (addAbilityRef.current) {
        let diff = [];
        if (appInfo.abilityList.length > oldAbilityRef.current.length) {
          diff = _.difference(appInfo.abilityList, oldAbilityRef.current);
        } else {
          diff = _.difference(oldAbilityRef.current, appInfo.abilityList);
        }
        history.push(
          `/${type}/appdetailV2/${pageList[diff[0]]}?id=${
            appInfo?.aliasName
          }&type=${type}`
        );
        addAbilityRef.current = false;
      }
      oldAbilityRef.current = appInfo.abilityList.sort();
    }
  }, [appInfo]);

  const appListInfo = useMemo(() => {
    let weShow = false,
      lightShow = false,
      robotShow = false;

    if (appInfo?.abilityList?.includes(abilityType.wecode)) {
      weShow = true;
    }
    if (appInfo?.abilityList?.includes(abilityType.h5)) {
      lightShow = true;
    }
    if (appInfo?.abilityList?.includes(abilityType.robot)) {
      robotShow = true;
    }
    let appConfig = {
      We码: {
        title: "We码",
        key: abilityType.wecode,
        desc:
          "一次开发适配多端，接近原生APP体验的小程序，支持React、Vue、Zepto等前端框架",
        background: robotBackground,
        icon: weIcon,
        open: weShow
      },
      轻应用: {
        title: "轻应用",
        key: abilityType.h5,
        desc:
          "一个H5地址即可发布应用，可将原业务系统简单改造后快速迁移至应用内",
        background: lightBackGround,
        icon: lightIcon,
        open: lightShow
      }
    };
    if (type === APP_TYPE.innerapp) {
      appConfig["机器人"] = {
        title: "机器人",
        key: abilityType.robot,
        desc:
          "与用户在聊天中交互的应用，它可以向用户或群组自动发送消息，响应用户的消息",
        background: weBackGround,
        icon: robotIcon,
        open: robotShow
      };
    }
    return appConfig;
  }, [appInfo]);

  const abilityTypeClick = item => {
    if (!Object.keys(appInfo).length) return;
    let jumpUrl = "",
      currentAbilityType = "";

    const abilityTypeDeal = {
      [abilityType.wecode]: () => {
        if (appInfo.abilityList.includes(abilityType.wecode)) {
          jumpUrl = `/${type}/appdetailV2/applicationWe?id=${appInfo?.aliasName}&type=${type}`;
        } else {
          currentAbilityType = abilityType.wecode;
        }
      },
      [abilityType.h5]: () => {
        if (appInfo.abilityList.includes(abilityType.h5)) {
          jumpUrl = `/${type}/appdetailV2/applicationLight?id=${appInfo?.aliasName}&type=${type}`;
        } else {
          currentAbilityType = abilityType.h5;
        }
      },
      [abilityType.robot]: () => {
        if (appInfo.abilityList.includes(abilityType.robot)) {
          jumpUrl = `/${type}/appdetailV2/applicationRobot?id=${appInfo?.aliasName}&type=${type}`;
        } else {
          currentAbilityType = abilityType.robot;
        }
      }
    };
    abilityTypeDeal?.[item.key]?.();
    jumpUrl && history.push(jumpUrl);
    currentAbilityType && addAbility(appInfo.aliasName, currentAbilityType);
  };

  /**
   * @description 添加应用能力
   * @param {string} appId
   * @param {'wecode'|'h5'|'robot'} abilityType
   */
  const addAbility = (appId, abilityType) => {
    doAddAbility({ appId, abilityType }, getAppPathFromType(type))
      .then(res => {
        if (res?.status === 1) {
          addAbilityRef.current = true;
          dispatch(
            actions.setAppInfo({
              ...appInfo,
              abilityList: [...appInfo.abilityList, abilityType]
            })
          );
        } else {
          message.warning(res.errMsg || "添加应用功能失败，请稍后重试！");
        }
      })
      .catch(err => {
        console.log(err);
        message.warning("添加应用功能失败，请稍后重试！");
      });
  };

  const capabilitiesCard = (item, index) => {
    if (item?.key === abilityType.robot && type === APP_TYPE.isv) {
      return null;
    }
    return (
      <div className={css["capabilities-card"]} key={index}>
        <div className={css["card-background-container"]}>
          <img src={urlDomainDeal(item.background)} alt="" />
        </div>
        <p>
          <img src={urlDomainDeal(item.icon)} alt="" />
          {item.title}
        </p>
        <p title={item.desc}>{item.desc}</p>
        <Button
          className={css["card-button"]}
          onClick={() => abilityTypeClick(item)}
        >
          <img src={item.open ? configIcon : addIcon} alt="" />
          <span
            className={classNames({
              [css["color-grey"]]: item.open
            })}
          >
            {item.open ? "配置" : "添加"}
          </span>
        </Button>
      </div>
    );
  };

  return (
    <main className={css["add-app-capabilities-container"]}>
      <p className={css["capabilities-title"]}>按能力添加</p>
      <div className={css["capabilities-list"]}>
        {Object.keys(appListInfo).map((item, index) => {
          return capabilitiesCard(appListInfo[item], index);
        })}
      </div>
    </main>
  );
};

export default AppCapabilitiesCard;
